<div class="button-menu">
  <ng-container *ngIf="previewWidth">
    <app-button-menu-item
      name="download-small"
      location="download-size-selection"
      (click)="onSelect.emit(previewWidth)"
      *ngIf="asset.version_data.data.width > previewWidth"
      [fullWidth]="true"
    >
      <div class="download-menu-item">
        <b [class.active]="previewWidth === activeWidth">Optimized</b>
        <span>({{ previewWidth }} x {{ getHeight(previewWidth) }})</span>
        <app-svg src="/assets/icons/check.svg" *ngIf="previewWidth === activeWidth"></app-svg>
      </div>
    </app-button-menu-item>
    <div class="divider"></div>
  </ng-container>

  <ng-container *ngFor="let size of sizes">
    <app-button-menu-item
      [name]="'download-' + (size.name | lowercase)"
      location="download-size-selection"
      (click)="onSelect.emit(size.size)"
      [fullWidth]="true"
    >
      <div class="download-menu-item">
        <b [class.active]="size.size === activeWidth">{{ size.name | translate }}</b>
        <span>({{ size.size }} x {{ getHeight(size.size) }})</span>
        <app-svg src="/assets/icons/check.svg" *ngIf="size.size === activeWidth"></app-svg>
      </div>
    </app-button-menu-item>
  </ng-container>

  <div class="divider" *ngIf="sizes.length && allowOriginalDownload"></div>
  <app-button-menu-item
    name="download-original"
    location="download-size-selection"
    (click)="onSelect.emit()"
    [fullWidth]="true"
    *ngIf="allowOriginalDownload"
  >
    <div class="download-menu-item">
      <b [class.active]="!asset.version_data.data || asset.version_data.data.width === activeWidth">{{
        'original-file' | translate
      }}</b>
      <span *ngIf="asset.version_data.data"
        >({{ asset.version_data.data.width }} x {{ asset.version_data.data.height }})</span
      >
      <app-svg src="/assets/icons/check.svg" *ngIf="asset.version_data.data?.width === activeWidth"></app-svg>
    </div>
  </app-button-menu-item>
</div>
